  <template>
  <notifications group="custom-notification" animation-type="velocity" position="top right">
   <template slot="body" slot-scope="props">
    <div class="vue-notification" v-bind:class="props.item.type">
        <a class="title">
          {{props.item.title}}
        </a>
        <a class="close" @click="props.close">
          <i class="fa fa-fw fa-close"></i>
        </a>
        <div style="font-size:15px;" v-html="props.item.text"></div>
    </div>
  </template>
  </notifications>
  </template>
<script>
  export default{
    name: "customNotification"
  }

</script>
<style lang="scss" scoped>
  .vue-notification {
  padding: 10px;
  margin: 0 5px 5px;
  font-size: 12px;
  color: #ffffff;

    &.warn {
      background: #ffb648;
      border-left-color: #f48a06;
    }

    &.error {
      background: #E54D42;
      border-left-color: #B82E24;
    }

    &.success {
      background: #68CD86;
      border-left-color: #42A85F;
    }
  }
  .vue-notification .title {
    color: #fff
  }
</style>
